import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from '@wegroup/design-system';
import React from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { compareProps } from '../../../../../../../tarifications/src/legacy/services/proFlowService';
import { prefilledInputComponentStyling } from '../../../../../../../flows/src/constants/InputComponentStyling';

interface Props {
  name?: string;
  value?: string | number;
  onChange: (boxNumber?: string | number) => void;
  onBlur?: () => void;
  error?: FieldError;
  isDisabled?: boolean;
  isPrefilled?: boolean;
}

const BoxNumber: React.FC<Props> = ({
  name,
  value,
  onChange,
  onBlur,
  isDisabled,
  isPrefilled,
  error,
}) => {
  const { t } = useTranslation();

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.value === '') onChange(undefined);
    else onChange(e.currentTarget.value);
  };

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel>{t('BUSNUMBER')}</FormLabel>
      <Input
        name={name}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        isDisabled={isDisabled}
        {...(value != null &&
          isPrefilled && { sx: prefilledInputComponentStyling })}
      />
      {error?.message && (
        <FormErrorMessage>{t(error.message)}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default React.memo(BoxNumber, compareProps);
